import { alpha } from '@mui/material';
/**
 * Gray colors by shade number
 */
export var white = '#fff';
export var gray02 = '#f3f7fa';
export var gray05 = '#eef3f9';
export var gray07 = '#e3ebf2';
export var gray10 = '#d0dbe6';
export var gray15 = '#becbd9';
export var gray20 = '#adbdcc';
export var gray25 = '#9eafbf';
export var gray30 = '#90a1b3';
export var gray35 = '#8395a6';
export var gray40 = '#778899';
export var gray45 = '#6c7c8c';
export var gray50 = '#617080';
export var gray55 = '#566573';
export var gray60 = '#4c5966';
export var gray65 = '#424e59';
export var gray70 = '#39434d';
export var gray75 = '#2f3740';
export var gray80 = '#252c33';
export var gray85 = '#1c2126';
export var gray90 = '#13161a';
export var gray95 = '#090b0d';
export var black = '#000';
/**
 * Opaque alternatives
 */
export var whiteopacity80 = alpha(white, 0.8);
export var whiteopacity33 = alpha(white, 0.33);
export var gray20opacity40 = alpha(gray20, 0.4);
export var gray35opacity40 = alpha(gray35, 0.4);
export var gray40opacity05 = alpha(gray40, 0.05);
export var gray40opacity10 = alpha(gray40, 0.1);
export var gray40opacity15 = alpha(gray40, 0.15);
export var gray40opacity20 = alpha(gray40, 0.2);
export var gray40opacity30 = alpha(gray40, 0.3);
export var gray40opacity40 = alpha(gray40, 0.4);
export var gray55opacity40 = alpha(gray55, 0.4);
export var gray80opacity40 = alpha(gray80, 0.4);
export var gray95opacity10 = alpha(gray95, 0.1);
export var gray95opacity40 = alpha(gray95, 0.4);
